/**
 * Converte segundos para minutos (arredondando para baixo).
 * @param seconds Número de segundos.
 * @returns Número de minutos.
 */
export function secondsToMinutes(seconds: number): number {
  return Math.floor(seconds / 60);
}
